module.exports = __webpack_public_path__ + "static/media/rest.6ff6693f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rest.jpg
// module id = 233
// module chunks = 0